import LevelTranslationsUpdateRequest from '../../../../../Spirit/Admin/Interfaces/Models/Level/LevelTranslationsUpdateRequest';

export default class UpdateLevelRequest  {
	LevelId?: number = null;
	NumberOfMinutes: number = 0;
	Translations: Array<LevelTranslationsUpdateRequest> = null;
	constructor(obj?: Partial<UpdateLevelRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
